import { RootState } from '../index';

export const getHistoryStocktakePage = (state: RootState) => state.historyStocktake.page;